import React from 'react';
interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  className?: string;
  variant?: 'default' | 'glass' | 'outline';
}
export function Card({
  children,
  className = '',
  variant = 'default',
  ...props
}: CardProps) {
  const variants = {
    default: 'bg-slate-900 border border-slate-800',
    glass: 'bg-slate-900/40 backdrop-blur-md border border-slate-800/50',
    outline: 'bg-transparent border border-slate-800'
  };
  return <div className={`rounded-xl p-6 md:p-8 ${variants[variant]} ${className}`} {...props} data-id="element-3">
      {children}
    </div>;
}